import { baseAPI } from '~shared/api/base-api';

export interface ExportPerformanceScheduleParams {
  recitalId: string;
  format?: 'csv' | 'pdf';
}

export const exportPerformanceSchedule = async ({
  recitalId,
  format = 'csv',
}: ExportPerformanceScheduleParams): Promise<Blob> => {
  const response = await baseAPI.get(
    `/recitals/${recitalId}/reports/schedule`,
    {
      params: { format },
      responseType: 'blob',
    },
  );
  return response.data;
};

export const downloadPerformanceSchedule = async (
  recitalId: string,
  format: 'csv' | 'pdf' = 'csv',
): Promise<void> => {
  const blob = await exportPerformanceSchedule({ recitalId, format });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `performance-schedule-${recitalId}.${format}`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
